export default __webpack_public_path__ + "static/linkedin-d7b146cfe89ee55f9fdbca5a1e0dfc41.png";